import { render, staticRenderFns } from "./Support4.vue?vue&type=template&id=1ea16070&scoped=true"
import script from "./Support4.vue?vue&type=script&lang=js"
export * from "./Support4.vue?vue&type=script&lang=js"
import style0 from "./Support4.vue?vue&type=style&index=0&id=1ea16070&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea16070",
  null
  
)

export default component.exports